const EVENT_LABELS = {
  diagnosis: 'Diagnosis',
  progression: 'Progression',
  relapse: 'Relapse',
  death: 'Patient death',
  secondary: 'Secondary',
  other: 'Other',
} as const;

const NO_EVENT_LABEL = '';

const SEQUENCED_EVENT_CODE_PATTERN = /^([A-Z])[0-9]$/;
const TRAILING_NUMBER_PATTERN = /[0-9]+$/;

interface IEventRule {
  label: string;
  keyword: string;
  codeLetter?: string;
}

const EVENT_RULES: readonly IEventRule[] = [
  { label: EVENT_LABELS.diagnosis, keyword: 'diagnosis', codeLetter: 'D' },
  { label: EVENT_LABELS.progression, keyword: 'progression', codeLetter: 'P' },
  { label: EVENT_LABELS.relapse, keyword: 'relapse', codeLetter: 'R' },
  { label: EVENT_LABELS.death, keyword: 'death' },
  { label: EVENT_LABELS.secondary, keyword: 'secondary', codeLetter: 'S' },
  { label: EVENT_LABELS.other, keyword: 'other', codeLetter: 'O' },
];

const findEventLabel = (event: string): string | undefined => {
  const [, codeLetter] = event.match(SEQUENCED_EVENT_CODE_PATTERN) ?? [];
  const normalisedEvent = event.toLowerCase();

  return EVENT_RULES.find(({ keyword, codeLetter: ruleCodeLetter }) => (
    (codeLetter !== undefined && ruleCodeLetter === codeLetter)
    || normalisedEvent.includes(keyword)
  ))?.label;
};

const mapEvent = (event?: string, includeNumber = false): string => {
  if (!event) return NO_EVENT_LABEL;

  const label = findEventLabel(event);
  if (!label) return event;

  const [trailingNumber] = event.match(TRAILING_NUMBER_PATTERN) ?? [];

  return includeNumber && trailingNumber ? `${label} ${trailingNumber}` : label;
};

export default mapEvent;
